import React from 'react';
import { Search, MapPin, Clock, Package } from 'lucide-react';

function DeliveryList({ deliveries, searchQuery, onSearchChange, onDeliveryClick, showList }) {
  function getStatusColor(status) {
    switch (status) {
      case 'pending':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'encamino':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'entregado':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'cancelado':
      case 'rechazado':
        return 'bg-red-100 text-red-700 border-red-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  }

  function getStatusLabel(status) {
    const labels = {
      pending: 'Pendiente',
      encamino: 'En Camino',
      entregado: 'Entregado',
      cancelado: 'Cancelado',
      rechazado: 'Rechazado',
    };
    return labels[status] || status;
  }

  return (
    <div
      className={`
        ${showList ? 'flex' : 'hidden lg:flex'}
        flex-col w-full lg:w-96 bg-white border-r border-slate-200 z-20
        absolute lg:relative inset-0 lg:inset-auto
      `}
    >
      {/* Search Bar */}
      <div className="p-4 border-b border-slate-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <input
            type="text"
            placeholder="Buscar por nombre, teléfono, ID..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] text-sm font-montserrat"
          />
        </div>
      </div>

      {/* Deliveries Count */}
      <div className="px-4 py-3 bg-slate-50 border-b border-slate-200">
        <p className="text-sm font-semibold text-slate-700 font-montserrat">
          {deliveries.length} {deliveries.length === 1 ? 'Entrega' : 'Entregas'}
        </p>
      </div>

      {/* Deliveries List */}
      <div className="flex-1 overflow-y-auto">
        {deliveries.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 px-4">
            <Package className="w-16 h-16 text-slate-300 mb-4" />
            <p className="text-sm text-slate-600 font-montserrat text-center">
              {searchQuery
                ? 'No se encontraron entregas'
                : 'No hay entregas disponibles'}
            </p>
          </div>
        ) : (
          <div className="divide-y divide-slate-200">
            {deliveries.map((delivery) => (
              <button
                key={delivery.id}
                onClick={() => onDeliveryClick(delivery)}
                className="w-full p-4 hover:bg-slate-50 transition-colors text-left"
              >
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-slate-900 font-montserrat truncate">
                      {delivery.recipient_name}
                    </h3>
                    <p className="text-xs text-slate-600 font-montserrat mt-0.5">
                      ID: {delivery.id}
                    </p>
                  </div>
                  <span
                    className={`px-2 py-1 text-xs font-semibold rounded-full border font-montserrat whitespace-nowrap ${getStatusColor(
                      delivery.status
                    )}`}
                  >
                    {getStatusLabel(delivery.status)}
                  </span>
                </div>

                <div className="space-y-1.5">
                  <div className="flex items-start gap-2">
                    <MapPin className="w-3.5 h-3.5 text-slate-400 mt-0.5 flex-shrink-0" />
                    <p className="text-xs text-slate-600 font-montserrat line-clamp-2">
                      {delivery.address}, {delivery.district}
                    </p>
                  </div>

                  {delivery.arrival_time && (
                    <div className="flex items-center gap-2">
                      <Clock className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
                      <p className="text-xs text-slate-600 font-montserrat">
                        {new Date(delivery.arrival_time).toLocaleString('es-PE', {
                          day: '2-digit',
                          month: 'short',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </p>
                    </div>
                  )}

                  {delivery.recipient_phone && (
                    <p className="text-xs text-slate-500 font-montserrat">
                      📞 {delivery.recipient_phone}
                    </p>
                  )}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DeliveryList;